// React
import React, { useState, useEffect, useCallback } from "react";
import DaumPostcode from 'react-daum-postcode';

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Window } from "@progress/kendo-react-dialogs";

// Css

// Service

// Component

const EldeAddress = ({ conn, elderInfo, setElderInfo, setInfo }) => {

  // 닫기 이벤트
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.addressInfo = false;
      return item;
    });
  }

  return (
    <Dialog 
      title={elderInfo.dataItem.userTerm +"님 장비 설치위치"} 
      onClose={closeEvt}
      width={"600px"}
      height={"580px"}
    >
      <DaumPostcode
        onComplete={setInfo}  // 값을 선택할 경우 실행되는 이벤트
        autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정
        style={{height : 470}}
      />
    </Dialog>
  );
};
export default EldeAddress;
